import React from 'react';
import { RouteObject } from 'react-router-dom';
import RedirectRoute from '../RedirectRoute';
import { appRoutes } from '../../path';
import ProtectedRoute from '../../components/ProtectedRoute';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import ViewCohorts from './ViewCohorts';
import CreateCohort from './CreateCohort';
import SidebarLayout from '../../Layout/SidebarLayout';
import CohortNav from './CohortNav';

const cohortRoutes: RouteObject[] = [
  {
    element: (
      <SidebarLayout>
        <CohortNav />
      </SidebarLayout>
    ),
    children: [
      // Redirect any cohort reports to new cohort nav KB-7176
      {
        path: '/report/cohort/*',
        element: (
          <RedirectRoute
            from="/report/cohort/*"
            to={appRoutes.cohorts.create}
          />
        ),
      },
      {
        path: '/cohorts',
        element: (
          <RedirectRoute from="/cohorts" to={appRoutes.cohorts.create} />
        ),
      },
      {
        path: appRoutes.cohorts.view,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.CohortRead]}
            pageNameWithSubPermissions={'cohort'}
          >
            <ViewCohorts />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.cohorts.create + '/:builderId?',
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.CohortReportRead]}
            pageNameWithSubPermissions={'cohort'}
          >
            <CreateCohort />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default cohortRoutes;
